const ShowUploadComponent = (This, obj) => {
  This.imgFile = obj
  document.querySelector(`#${This.uploadId + This.goodsItem.index}`).click()
}

export { ShowUploadComponent }